import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import Item from './Item.js';
import { SelectStates } from '../common.js';
import { isObjectItem } from './common.js';
import useFloatingUiTrialContext from '../../../FloatingUiTrial/useFloatingUiTrialContext.js';
import SelectField$1 from './SelectFieldNew.js';
import SelectField$2 from './SelectFieldOld.js';
import { EmphasisLM } from '../../../types.js';

function DefaultItemRender(item) {
    if (isObjectItem(item)) {
        return null;
    }
    return jsx(Item, { title: item });
}
const SelectFieldComp = React__default.forwardRef((props, ref) => {
    const { floatingUiActive } = useFloatingUiTrialContext();
    return floatingUiActive ? jsx(SelectField$1, Object.assign({}, props, { ref: ref })) : jsx(SelectField$2, Object.assign({}, props, { ref: ref }));
});
SelectFieldComp.defaultProps = {
    searchValue: undefined,
    onSelected: undefined,
    className: undefined,
    componentHeight: undefined,
    listClassName: undefined,
    disabled: false,
    onKeyDown: undefined,
    placeholder: undefined,
    readOnly: false,
    title: undefined,
    titleIcon: undefined,
    icon: undefined,
    inputProps: undefined,
    state: undefined,
    stateMessage: undefined,
    helperText: undefined,
    onSearchValueChange: undefined,
    renderItem: DefaultItemRender,
    onAddItem: undefined,
    onRemoveItem: undefined,
    onUpdateItem: undefined,
    listRight: false,
    listTop: false,
    onShowLastItem: undefined,
    itemKeyProperty: undefined,
    emphasis: EmphasisLM.MEDIUM,
    onSelectBlur: undefined,
    tooltipProps: undefined,
    addItemLabel: 'Aggiungi voce alla lista',
    flowMode: undefined,
};
const SelectFieldDefaultProps = SelectFieldComp.defaultProps;
/**
Componente che permette di scegliere un valore tra una lista di elementi.

__Il componente è la versione controlled di `Combobox`. Se possibile utilizzare questo componente__

Vedi [Design System di CGN - Campi di Input - Combobox](https://zeroheight.com/1b5e94371/p/940c42-campi-di-input/b/405dcb)

Alla scrittura delle testo verrà attivata una callback (`onLoadItems`) e comparirà il popup.
Al click di un elemento del popup il valore verrà selezionato (`onSelected`).

La lista gestisce anche le operazioni CUD.
Per inserire un elemento, aggiungere la callback `onAddItem`.
Per modificare/cancellare un elemento aggiungere la callback onUpdateItem/onRemoveItem e impostare la proprietà `enableUpdate=true` sull'elemento della lista.

E' possibile anche disabilitare la scelta di un elemento aggiungendo la proprietà `disabled=true`,

Il rendering dei componenti è svolto dalla funzione `renderItem`. Si consiglia l'utilizzo del componente `Select.Item`.
Nel caso di liste di oggetti, usare la proprietà `key` per definire un identificativo univoco dell'elemento.

Ref:
- `selectItem`: funzione per selezionare un valore.
- `focus`: funzione per tentare di acquisire il focus.
- `contains`: funzione per verificare se il componente "contiene" un altro componente nel suo sotto albero.
- `getValue`: ritorna il valore nell'input.
- `hidePopup`: nasconde la lista degli elementi.

Constants:
- `Select.States`: stati ammessi per la proprietà state;

*/
const SelectField = SelectFieldComp;
SelectField.States = SelectStates;
SelectField.Item = Item;

export { SelectFieldDefaultProps, SelectField as default };
